const o = "UnbundlingFareInfographic-module_container__-PoJl",
  n = "UnbundlingFareInfographic-module_groups__9Zwej",
  e = "UnbundlingFareInfographic-module_group__XDQjT",
  r = "UnbundlingFareInfographic-module_group-header-icon__oaepO",
  t = "UnbundlingFareInfographic-module_steps-group-content__CHa77",
  p = "UnbundlingFareInfographic-module_title-tag__JiK5X",
  g = "UnbundlingFareInfographic-module_group-header__k2Lo0",
  a = "UnbundlingFareInfographic-module_steps__cUJ7M",
  u = "UnbundlingFareInfographic-module_step-footnote__2moIV",
  s = {
    container: o,
    groups: n,
    group: e,
    groupHeaderIcon: r,
    stepsGroupContent: t,
    titleTag: p,
    groupHeader: g,
    steps: a,
    stepFootnote: u
  };
export { s };